import Cookies from 'js-cookie';
import ConstantApi from '../../ConstantApi';
import { fetchAreaMaster } from '../areaMaster/areaMaster.actions';
import axiosCall from '../axiosCall';
import { fetchAreaCompanyMaster } from '../companyMaster/companyMaster.actions';
import { fetchBankName, fetchPartyMasterData, fetchPropertyDataForPartyMasterMaster } from '../partyMaster/partyMaster.actions';
import { fetchCommonPropertyById } from '../property/common/commonProperty.actions';
import {
    CREATE_PARTY_DETAILS_FAILURE,
    CREATE_PARTY_DETAILS_FORM,
    CREATE_PARTY_DETAILS_REQUEST,
    CREATE_PARTY_DETAILS_SUCCESS,
    DELETE_PARTY_DETAILS_FAILURE,
    DELETE_PARTY_DETAILS_REQUEST,
    DELETE_PARTY_DETAILS_SUCCESS,
    FETCH_PARTY_DETAILS_FAILURE,
    FETCH_PARTY_DETAILS_GST_FILE_FAILURE,
    FETCH_PARTY_DETAILS_GST_FILE_REQUEST,
    FETCH_PARTY_DETAILS_GST_FILE_SUCCESS,
    FETCH_PARTY_DETAILS_PAN_FILE_FAILURE,
    FETCH_PARTY_DETAILS_PAN_FILE_REQUEST,
    FETCH_PARTY_DETAILS_PAN_FILE_SUCCESS,
    FETCH_PARTY_DETAILS_REQUEST,
    FETCH_PARTY_DETAILS_SUCCESS,
    FETCH_PARTY_DETAILS_WITHOUT_ID_FAILURE,
    FETCH_PARTY_DETAILS_WITHOUT_ID_REQUEST,
    FETCH_PARTY_DETAILS_WITHOUT_ID_SUCCESS,
    FETCH_SINGLE_PARTY_DETAILS_FAILURE,
    FETCH_SINGLE_PARTY_DETAILS_REQUEST,
    FETCH_SINGLE_PARTY_DETAILS_SUCCESS,
    RESET_PARTY_DETAILS_INFO,
    UPDATE_PARTY_DETAILS_FAILURE,
    UPDATE_PARTY_DETAILS_REQUEST,
    UPDATE_PARTY_DETAILS_SUCCESS
} from './partyDetails.actionsType';
import Config from '../../config';
import axios from 'axios';

// FETCH PARTY DETAILS DATA  ?FldFKParty=12
export let fetchPartyDetailsWithIdData = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.partyDetailsGET_BY_ID}?FldFKParty=${id}`,
        responseTypeRequest: FETCH_PARTY_DETAILS_REQUEST,
        responseTypeSuccess: FETCH_PARTY_DETAILS_SUCCESS,
        responseTypeFailure: FETCH_PARTY_DETAILS_FAILURE
    };
    return axiosCall(config);
};

// FETCH PARTY DETAILS DATA
export let fetchPartyDetailsData = (id) => {
    let config = {
        method: 'get',
        url: ConstantApi.partyDetailsGET,
        responseTypeRequest: FETCH_PARTY_DETAILS_WITHOUT_ID_REQUEST,
        responseTypeSuccess: FETCH_PARTY_DETAILS_WITHOUT_ID_SUCCESS,
        responseTypeFailure: FETCH_PARTY_DETAILS_WITHOUT_ID_FAILURE
    };
    return axiosCall(config);
};

// CREATE PARTY DETAILS FORM
export let createPartyDetailsForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_PARTY_DETAILS_FORM, payload: { key, value } });
    };
};

// CREATE PARTY DETAILS
export let createPartyDetails = (formData, modalClose, parentId) => {
    let today = new Date();
    // let data = JSON.stringify({
    //     fldId: 0,
    //     fldIsActive: true,
    //     fldCreatedBy: 1,
    //     fldCreatedDt: today.toISOString(),
    //     fldModifiedBy: 0,
    //     fldModifiedDt: today.toISOString(),
    //     fldDeletedBy: 0,
    //     fldDeletedDt: today.toISOString(),
    //     fldIsPartyMaster: true,
    //     fldIsHeaderInfo: true,
    //     ...formData,
    //     fldAdditionalContactNumber: formData?.fldAdditionalContactNumber ? formData?.fldAdditionalContactNumber : '',
    //     fldMachineryInfo: formData?.fldMachineryInfo ? formData?.fldMachineryInfo : '',
    //     fldProductionCapacityPerDay: formData?.fldProductionCapacityPerDay ? formData?.fldProductionCapacityPerDay : '',
    //     fldGSTFileName: formData?.fldGSTFileName ? formData?.fldGSTFileName : '',
    //     fldPANFileName: formData?.fldPANFileName ? formData?.fldPANFileName : '',
    //     fldFKParty: parseInt(formData.fldFKParty),
    //     fldUnitType: formData.fldUnitType.toString(),
    //     fldFKCategory: parseInt(formData.fldFKCategory),
    //     fldFKArea: parseInt(formData.fldFKArea),
    //     fldFKType: formData.fldUnitType[0] || 0,
    //     fldFKBankName: parseInt(formData.fldFKBankName),
    //     fldBankName: 'string',
    //     fldTDS: formData.fldTDS.split('.').length >= 2 ? parseFloat(formData.fldTDS) : parseInt(formData.fldTDS),
    //     fldTCS: formData.fldTCS.split('.').length >= 2 ? parseFloat(formData.fldTCS) : parseInt(formData.fldTCS),
    //     FldUnitTypeDetails: 'string'
    //     // fldAddress2: formData.fldAddress2 ? formData.fldAddress2 : ''
    // });
    let config = {
        method: 'post',
        data: formData,
        url: `${ConstantApi.partyDetailsPOST}?FldFkPartyMasterID=${parentId}`,
        responseTypeRequest: CREATE_PARTY_DETAILS_REQUEST,
        responseTypeSuccess: CREATE_PARTY_DETAILS_SUCCESS,
        responseTypeFailure: CREATE_PARTY_DETAILS_FAILURE,
        resetFormData: RESET_PARTY_DETAILS_INFO,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchPartyDetailsWithIdData(parentId)
    };
    return axiosCall(config);
};

// GET SINGLE PARTY DETAILS
export let getSinglePartyDetails = (id) => {
    // let config = {
    //     method: 'get',
    //     url: `${ConstantApi.partyDetailsGETID}/${id}`,
    //     responseTypeRequest: FETCH_SINGLE_PARTY_DETAILS_REQUEST,
    //     responseTypeSuccess: FETCH_SINGLE_PARTY_DETAILS_SUCCESS,
    //     responseTypeFailure: FETCH_SINGLE_PARTY_DETAILS_FAILURE,
    //     singlApiArray: [
    //         fetchPropertyDataForPartyMasterMaster(31), // Party Category
    //         fetchPropertyDataForPartyMasterMaster(23), // Program Type
    //         fetchAreaCompanyMaster(),
    //         fetchAreaMaster(),
    //         fetchPartyMasterData(),
    //         fetchBankName()
    //     ]
    // };
    // return axiosCall(config);
    return (dispatch) => {
        dispatch({ type: FETCH_SINGLE_PARTY_DETAILS_REQUEST });
        var config = {
            method: 'get',
            url: `${Config.baseUrl}${ConstantApi.partyDetailsGETID}/${id}`,
            headers: {
                // 'Access-Control-Allow-Origin': true,
                'Content-Type': 'application/json',
                Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                dbname: Cookies.get('DATABASE')
            }
        };
        axios(config)
            .then((response) => {
                dispatch({ type: FETCH_SINGLE_PARTY_DETAILS_SUCCESS, updatePayload: response.data });
                dispatch(fetchPartyDetailPANFile(response?.data?.fldPANFileName, response?.data?.fldId));
                dispatch(fetchPartyDetailGSTFile(response?.data?.fldGSTFileName, response?.data?.fldId));
                dispatch(fetchPropertyDataForPartyMasterMaster(31));
                dispatch(fetchPropertyDataForPartyMasterMaster(23));
                dispatch(fetchCommonPropertyById(67));
                dispatch(fetchAreaMaster());
                dispatch(fetchAreaCompanyMaster());
                dispatch(fetchPartyMasterData());
                dispatch(fetchBankName()); //source
            })
            .catch((error) => {
                dispatch({ type: FETCH_SINGLE_PARTY_DETAILS_FAILURE, payload: error });
            });
    };
};

export let fetchPartyDetailPANFile = (fileName, id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.partyMasterPANFileGET}?FldFileName=${fileName}&FldFileType=PAN&FldId=${id}`,
        responseTypeRequest: FETCH_PARTY_DETAILS_PAN_FILE_REQUEST,
        responseTypeSuccess: FETCH_PARTY_DETAILS_PAN_FILE_SUCCESS,
        responseTypeFailure: FETCH_PARTY_DETAILS_PAN_FILE_FAILURE
    };
    return axiosCall(config);
};

export let fetchPartyDetailGSTFile = (fileName, id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.partyMasterPANFileGET}?FldFileName=${fileName}&FldFileType=GST&FldId=${id}`,
        responseTypeRequest: FETCH_PARTY_DETAILS_GST_FILE_REQUEST,
        responseTypeSuccess: FETCH_PARTY_DETAILS_GST_FILE_SUCCESS,
        responseTypeFailure: FETCH_PARTY_DETAILS_GST_FILE_FAILURE
    };
    return axiosCall(config);
};

//UPDATE PARTY DETAILS
export let updatePartyDetails = (formData, parentId, id) => {
    let today = new Date();
    // let data = {
    //     ...formData,
    //     fldAdditionalContactNumber: formData?.fldAdditionalContactNumber ? formData?.fldAdditionalContactNumber : '',
    //     fldMachineryInfo: formData?.fldMachineryInfo ? formData?.fldMachineryInfo : '',
    //     fldProductionCapacityPerDay: formData?.fldProductionCapacityPerDay ? formData?.fldProductionCapacityPerDay : '',
    //     fldGSTFileName: formData?.fldGSTFileName ? formData?.fldGSTFileName : '',
    //     fldPANFileName: formData?.fldPANFileName ? formData?.fldPANFileName : '',
    //     fldModifiedBy: 1,
    //     fldModifiedDt: today.toISOString(),
    //     fldFKParty: parseInt(formData.fldFKParty),
    //     fldFKCategory: parseInt(formData.fldFKCategory),
    //     fldFKArea: parseInt(formData.fldFKArea),
    //     fldFKType: parseInt(formData.fldFKType),
    //     fldFKBankName: parseInt(formData.fldFKBankName),
    //     fldFKAccType: parseInt(formData.fldFKAccType),
    //     fldUnitType: formData.fldUnitType.toString(),
    //     fldTDS: formData.fldTDS.split('.').length >= 2 ? parseFloat(formData.fldTDS) : parseInt(formData.fldTDS),
    //     fldTCS: formData.fldTCS.split('.').length >= 2 ? parseFloat(formData.fldTCS) : parseInt(formData.fldTCS),
    //     FldUnitTypeDetails: formData.fldUnitTypeDetails
    //     // fldAddress2: formData.fldAddress2 ? formData.fldAddress2 : ''
    // };
    let config = {
        method: 'patch',
        data: formData,
        url: `${ConstantApi.partyDetailsPATCH}/${id}?FldFkPartyMasterID=${parentId}`,
        responseTypeRequest: UPDATE_PARTY_DETAILS_REQUEST,
        responseTypeSuccess: UPDATE_PARTY_DETAILS_SUCCESS,
        responseTypeFailure: UPDATE_PARTY_DETAILS_FAILURE,
        resetFormData: RESET_PARTY_DETAILS_INFO,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchPartyDetailsWithIdData(parentId)
    };
    return axiosCall(config);
};

// DELETE PARTY DETAILS
export let deletePartyDetails = (id, parentId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.partyDetailsDELETE}/${id}`,
        responseTypeRequest: DELETE_PARTY_DETAILS_REQUEST,
        responseTypeSuccess: DELETE_PARTY_DETAILS_SUCCESS,
        responseTypeFailure: DELETE_PARTY_DETAILS_FAILURE,
        modalClose: true,
        getAllData: fetchPartyDetailsWithIdData(parentId)
    };
    return axiosCall(config);
};
